import React, { useState } from 'react';
import { useMask } from '@react-input/mask';

const Expiration = ({
	placeholder,
	error,
	name,
	type,
	width,
	value,
	margin,
	handleChange,
	icon,
	max,
	comment,
	dataCy,
}) => {
	const inputRef = useMask({ mask: '__/__', replacement: { _: /\d/ } });
	const [isTouched, setIsTouched] = useState(false);
	return (
		<div
			className="input-container"
			style={{
				width: width == 'full' ? '100%' : `calc(${width == 'half' ? 50 : width}% - 6px)`,
				marginRight: margin ? '12px' : '0px',
				backgroundColor: 'transparent',
			}}
		>
			<div className={`input input--text ${error && 'input--error'}`}>
				<input
					data-cy={dataCy}
					value={value}
					ref={inputRef}
					maxLength={max}
					className="styledInput"
					type={type}
					name={name}
					autoComplete="cc-exp"
					onBlur={() => {
						setIsTouched(false);
					}}
					onFocus={() => {
						setIsTouched(true);
					}}
					onChange={handleChange}
				/>

				<label className={value?.length > 0 || isTouched ? 'styledLabel styledLabel--active' : 'styledLabel'}>
					{placeholder}
				</label>

				{icon && (
					<div
						className="input__img"
						style={{
							backgroundImage: `url(${icon}`,
						}}
					>
						{comment && <span className="input__comment">{comment}</span>}
					</div>
				)}
			</div>
			{error && <span className="formError">{error}</span>}
		</div>
	);
};

export default Expiration;
